import styled from '@emotion/styled'
import {theme} from '../../theme'

export const TabsContainer = styled.div`
  display: flex;
  padding: 0 10px;
`

export const TabItem = styled.div`
  flex: 1;
  padding: ${({variant}) =>
    variant === 'payment'
      ? '12px 18px'
      : `${theme.space[1]} ${theme.space[2]}`};
  font-size: 13px;
  cursor: pointer;
  border-bottom: ${({active, borderColor}) =>
    active ? `3px solid ${borderColor || theme.colors.border.brand}` : 'none'};
  background: ${({active, activeBackground}) =>
    active ? activeBackground || theme.colors.gradient.thryvSurface : 'none'};

  &:last-child {
    border-right: none;
  }

  .amount {
    font-size: ${theme.fontSizes['2xl']};
    font-weight: ${theme.fontWeights.bold};

    span {
      font-size: ${theme.fontSizes.md};
    }

    &.blue {
      color: ${theme.colors.text.brand};
    }
  }

  .label {
    font-size: ${theme.fontSizes.sm};
    color: ${theme.colors.text.secondary};
    font-weight: ${theme.fontWeights.bold};

    span {
      font-weight: ${theme.fontWeights.regular};
    }

    &.blue {
      color: ${theme.colors.text.brand};
    }
  }
`
